import { render, staticRenderFns } from "./dragndrop.vue?vue&type=template&id=acfb47ee&scoped=true&"
import script from "./dragndrop.vue?vue&type=script&lang=js&"
export * from "./dragndrop.vue?vue&type=script&lang=js&"
import style0 from "./dragndrop.vue?vue&type=style&index=0&id=acfb47ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfb47ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCalendar,VCol,VRow,VSheet})
